import { render, staticRenderFns } from "./page.html?vue&type=template&id=627549dd&scoped=true&external"
import script from "./page.js?vue&type=script&lang=js&external"
export * from "./page.js?vue&type=script&lang=js&external"
import style0 from "./page.scss?vue&type=style&index=0&id=627549dd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627549dd",
  null
  
)

export default component.exports